module.exports = __webpack_public_path__ + "static/media/icons_universal.67a3fb57.png";